/**
 * Shared slider-dot pagination logic.
 *
 * Usage in section HTML:
 *   <script>
 *     window.sliderDots.init('track-id', 'dots-id', '.dot-class', '.slide-class');
 *   </script>
 */
(function () {
  'use strict';

  function init(trackId, dotsId, dotSelector, slideSelector) {
    var track = document.getElementById(trackId);
    var dotsWrap = document.getElementById(dotsId);
    if (!track || !dotsWrap) return;

    var dots = Array.from(dotsWrap.querySelectorAll(dotSelector));
    var slides = Array.from(track.querySelectorAll(slideSelector));

    function setActive(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle(dotSelector.replace('.', '') + '--active', i === index);
      });
    }

    var leadingOffset = 0;
    function updateLeadingOffset() {
      if (!slides.length) {
        leadingOffset = 0;
        return;
      }
      leadingOffset = Math.max(0, slides[0].offsetLeft);
    }

    updateLeadingOffset();
    window.addEventListener('resize', updateLeadingOffset);

    track.addEventListener(
      'scroll',
      function () {
        if (!slides[0]) return;
        var slideW = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var normalizedScroll = Math.max(0, track.scrollLeft - leadingOffset);
        var index = Math.round(normalizedScroll / (slideW + gap));
        setActive(Math.max(0, Math.min(index, slides.length - 1)));
      },
      { passive: true },
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10);
        var slideW = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var target = leadingOffset + index * (slideW + gap);
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
  }

  window.sliderDots = { init: init };
})();
